import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const projectsPageK = {
  user: "projects_page.user",
  areYouSureDeleteProject: "projects_page.areYouSureDeleteProject",
  myConfigurations: "projects_page.myConfigurations",
  projects: "projects_page.projects",
  projectName: "projects_page.projectName",
  private: "projects_page.private",
  users: "projects_page.users",
  editProjectDetails: "projects_page.editProjectDetails",
  addItems: "projects_page.addItems",
  deleteProject: "projects_page.deleteProject",
  visibility: "projects_page.visibility",
  public: "projects_page.public",
  newProject: "projects_page.newProject",
};

export const useProjectsPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      user: t(projectsPageK.user),
      areYouSureDeleteProject: t(projectsPageK.areYouSureDeleteProject),
      myConfigurations: t(projectsPageK.myConfigurations),
      projects: t(projectsPageK.projects),
      projectName: t(projectsPageK.projectName),
      private: t(projectsPageK.private),
      users: t(projectsPageK.users),
      editProjectDetails: t(projectsPageK.editProjectDetails),
      addItems: t(projectsPageK.addItems),
      deleteProject: t(projectsPageK.deleteProject),
      visibility: t(projectsPageK.visibility),
      public: t(projectsPageK.public),
      newProject: t(projectsPageK.newProject),
    }),
    [i18n.language]
  );
};